export default __webpack_public_path__ + "static/media/misc-pantry2-768w.57b3c463.webp";